
import Calculator from "../Calculator.vue";
export default { components: { Calculator } };
